<script>
import CustomersApi from "@/services/customers-api";
import Swal from "sweetalert2";
import i18n from "../../../i18n";
import BackOrdersApi from "@/services/backOrders-api";
import OrderModal from "@/components/orderModal"
import {Priviliges} from "../../../privileges";
import UsersApi from "@/services/users-api";

/**
 * Carts-list component
 */
export default {

  mounted(){
    this.role=sessionStorage.getItem("userr");
    if(this.role==1){
      this.getCustomers()
      this.setSimulatedCustomer(true)

    }
    if(sessionStorage.getItem("privileges")!=null){
        this.privileges=sessionStorage.getItem("privileges")
        this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
        this.hasBackOrderCancelAccess=this.privileges.includes(Priviliges[0]["BackOrder_Cancel"] )
    }
    if(this.role==0){
        this.findBackOrders()
    }
    // this.getSimulatedCustomer()


  },

  components: { OrderModal},
  data() {
    return {
        selected:null,
        role:null,
        customersList:[],
        isTableLoading:false,
        itemsList:[],
        itemsListFieldsForSupplier: [
            { key:"selection",label:"",thClass:"text-center", tdClass:"text-center"},
            { key:"creationDateStr", thClass:"text-left", tdClass:"text-left "},
            { key:"customerName", thClass:"text-left", tdClass:"text-left font-weight-bold"},
            { key:"itemRef", thClass:"text-left", tdClass:"text-left  font-weight-bold "},
            { key:"itemTitle", thClass:"text-left d-md-table-cell d-none", tdClass:"text-left  font-weight-bold d-md-table-cell d-none"},
            { key:"discountedPrice",label:"", thClass:"text-right ", tdClass:"text-right "},
            { key:"stockStatus",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"quantity", label:"", thClass:"text-center", tdClass:"text-center align-middle font-weight-bold "},
            { key:"action",label:"",thClass:"text-center", tdClass:"text-center align-middle"},
        ],
        itemsListFieldsForCustomer: [
            { key:"selection",label:"",thClass:"text-center", tdClass:"text-center"},
            { key:"creationDateStr", thClass:"text-left", tdClass:"text-left font-weight-bold"},
            { key:"itemRef", thClass:"text-left", tdClass:"text-left  font-weight-bold  "},
            { key:"itemTitle", thClass:"text-left d-md-table-cell d-none", tdClass:"text-left  font-weight-bold d-md-table-cell d-none"},
            { key:"discountedPrice",label:"", thClass:"text-right", tdClass:"text-right "},
            { key:"stockStatus",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"quantity", label:"", thClass:"text-center", tdClass:"text-center align-middle font-weight-bold "},
            { key:"action",label:"",thClass:"text-center", tdClass:"text-center align-middle"},
        ],
        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
        selectedBackOrders:new Set(),
        order: {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0},   
        optionsPriorities: [
            { value: 0, name: 'Basse : veuillez selectionner la date de livraison souhaitée' },
            { value: 1, name: "Normale : livraison J+1" },
            { value: 2, name: "Urgente: livraison le jour même"  },
          ],
        selectedPriority: { value: 1, name: 'Normale : livraison J+1' },
        promotionCode:null,
        orderMessage:'',
        desiredDeliveryDate:null,
        optionsDeliveryAddresses: [],
        selectedDeliveryAddress: null,
        isSubmittingOrder:false,
        showOrdersDetailsModal:false,
        showAlert:false,
        refFilter:null,
        privileges:"",
        isAdmin:false,
        hasBackOrderCancelAccess :false,
        selectedCustomer:null,
        isConversionStarting:false,
        isQuantityEditStarting:false,
        isCancelBackOrderStarting:false
    };
  }, 
  methods:{
    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
        response => {
          this.customersList=response;
        }
      )
    },

    findBackOrders() {
      this.isTableLoading = true;
      BackOrdersApi.getBackOrders(this.pagemodel.currentPage, this.pagemodel.perPage,this.refFilter,this.selectedCustomer).then(
          (result)=>{
              if(result){
                this.itemsList = result.list
                this.pagemodel.totalRows = result.total;
                this.pagemodel.currentPage = result.page;
                this.pagemodel.perPage = result.pageSize;
                this.pagemodel.pageSize = result.pageSize;
                var varSelectedBackOrders = this.selectedBackOrders 
                this.itemsList.forEach(function(item){
                    item.edit = false;
                    if(varSelectedBackOrders.has(item.id)){
                        item.selected=1
                    }else{
                        item.selected=0
                    }
                });
              }
          }
      ).finally(
          ()=>{
            this.isTableLoading = false
          }
      )

      },

      cancelBackOrder(line){
        Swal.fire({
            title: i18n.t("cartTab.cancelBackOrder.swal.title"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f46a6a",
            cancelButtonColor: "#34c38f",
            cancelButtonText: i18n.t("cartTab.cancelBackOrder.swal.cancelButtonText"),
            confirmButtonText: i18n.t("cartTab.cancelBackOrder.swal.confirmButtonText")
        })
        .then(result => {
            if (result.value) {
                this.isCancelBackOrderStarting=true

            BackOrdersApi.cancelBackOrder(line==null ? null : line.id)
                .then((result) => {
                        if (result) {
                            this.findBackOrders()
                        } 
                        this.isCancelBackOrderStarting=false
                })
            }
        });

      },

    editBackOrderQuantity(item) {
      item.edit=true;

      let input = this.$refs['confirmedQuantityEdit-' + item.id];
      input.focus();
    },

    saveBackOrderQuantity(line){
        this.isQuantityEditStarting=true
        BackOrdersApi.saveBackOrderQuantity(line==null ? null :line.id,line.quantity).then(
            (result)=>{
                if(result){
                    line.edit=false;
                    this.findBackOrders()
                }
                this.isQuantityEditStarting=false
            }
        )
        
    },

    editSelection(item){
        if(item.selected ==1){
            this.selectedBackOrders.add(item.id)
            this.showAlert=false

        }else{
            this.selectedBackOrders.delete(item.id)
        }
    },

      convert(){
        let array = Array.from(this.selectedBackOrders);
        if(!array.length){
            this.showAlert=true
            return;
        }else{
            this.showAlert=false
        }

        Swal.fire({
            title: i18n.t('cartTab.swal.title'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#f46a6a",
            cancelButtonColor: "#34c38f",
            cancelButtonText: i18n.t('cartTab.swal.cancelButtonText'),
            confirmButtonText: i18n.t('cartTab.swal.confirmButtonText')
        }).then(
            result =>{
                if(result.value){
                    this.isConversionStarting=true
                    BackOrdersApi.convertToOrder(array).then(
                        (result)=>{
                            this.isConversionStarting=false
                            if(result){
                                this.findBackOrders()
                                this.order=result
                                this.showOrdersDetailsModal=true
                            }
                        }
                    )
                }
            }
        )

      },


    closeOrderModal(){
        this.showOrdersDetailsModal=false
        this.showAlert=false;
    },

    setSimulatedCustomer(isMounted){
      UsersApi.setSimulatedCustomer(isMounted ? null : this.selected==null ? null : this.selected.id).then(
        (result)=>{
          if(result){
            this.findBackOrders()
          }
        }
      )
    },

    getSimulatedCustomer(){
      UsersApi.getSimulatedCustomer().then(
        (result)=>{
          if(result){
            this.selected=result
          }
        }
      )
    },

  },
    watch: {
        selected: function() {
            this.selectedCustomer = this.selected ? this.selected.id : null
            this.setSimulatedCustomer()
        },

    }       
    }

</script>
<template>
      <div>
        <div  class="row mb-0 ">
            <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-4 " :class="role==0 ? 'pb-4' : ''">
                <b-form-group :label="$t('cartTab.filter')" >
                        <b-input-group>
                            <b-form-input :placeholder="$t('cartTab.reference')" v-model="refFilter"   @keyup.native.enter="findBackOrders()"
                                ></b-form-input>    
                            <template v-slot:append>
                                <b-button  variant="warning" @click="findBackOrders()">
                                <i class="bx bx-search-alt  font-weight-bold font-size-16 text-primary align-middle"></i>
                                </b-button>
                            </template>                            
                        </b-input-group>
                </b-form-group>
            </div>
            <div class="col-lg-4  col-md-12"/>
            <div v-if="role==1" class="col-lg-4 col-md-12 col-xs-12  ">
                <div class="pb-1"><span class="text-secondary pb-4" > <i class="mdi mdi-eye pr-2 text-secondary" style="font-size:12px;"></i>{{$t("catalog.simulatedCustomer.label")}}</span></div>
                <b-form-group  label-for="">
                    <v-select class="style-vselect font-size-16"  :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
                        <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                    </v-select>
                </b-form-group>
            </div>
            <div  :class="role==0 ? 'col-lg-4 col-md-12 col-xs-12 mt-sm-4 pb-4 pb-xl-0 pb-lg-0' : 'col-12 pb-4 ' ">
                    <b-button @click="convert()" variant="light" class="float-right ">
                        <i class="fas fa-retweet text-primary font-size-16 align-middle mr-2"></i>
                        <span class="font-weight-bold text-primary text-uppercase"> {{$t('cartTab.convertButton')}}</span>
                    </b-button> 
            </div>
        </div>

        <b-alert :show=" showAlert"  variant="danger" class="w-50 d-none d-lg-block">
            <i class="fas fa-exclamation-triangle mr-2"></i>{{$t('cartTab.alertButton')}}
        </b-alert>

        <b-alert :show="showAlert"  variant="danger" class="w-100 mt-4 d-block d-lg-none">
            <i class="fas fa-exclamation-triangle mr-2"></i>{{$t('cartTab.alertButton')}}
        </b-alert>

        <div class="table-responsive">        
        <b-table 
        :striped="true"
        :small="false"
        :hover="true"
        :busy="isTableLoading"
        :items="itemsList"
        :fields="role==0 ? itemsListFieldsForCustomer :   hasBackOrderCancelAccess || isAdmin ?  itemsListFieldsForSupplier : []"
        :perPage="pagemodel.perPage"
        class="table  "
        >
        <template v-slot:head(creationDateStr)>
            {{ $t("cartTab.listFields.addToBackOrderDate") }} 
        </template>
        <template v-slot:head(customerName)>
            {{ $t("cartTab.listFields.customerName") }} 
        </template>
        <template v-slot:head(itemRef)>
            {{ $t("cartTab.listFields.ref") }} 
        </template>
        <template v-slot:head(itemTitle)>
            {{ $t("cartTab.listFields.itemTitle") }} 
        </template>
        <template v-slot:head(quantity)>
            {{ $t("cartTab.listFields.backOrderQantity") }} 
        </template>
        <template v-slot:head(stockStatus)>
            {{ $t("catalog.header.stockStatus") }} 
        </template>
        <template v-slot:head(discountedPrice)>
            {{ $t("cartTab.listFields.discountedPrice") }} 
        </template>
        <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
        </template>
        <template v-slot:cell(selection)="{item}" v-if="role==0 || selected!=null">
              <b-form-checkbox
                value="1"
                unchecked-value="0"
                class="custom-checkbox-success mb-3"
                v-model="item.selected"
                @input="editSelection(item)"
                ></b-form-checkbox
                >
        </template>
        <template v-slot:cell(quantity)="{item}">
            <div v-if="!isQuantityEditStarting" >
                <div v-show="!item.edit" @click="editBackOrderQuantity(item)" >
                    {{ item.quantity}} 
                    <i  class="fas fa-edit font-size-16 ml-2"  style="cursor:pointer" :title="$t('cartTab.editQuantity')"></i>
                </div>
                <div class="input-group input-group-sm pull-right mb-0" style="width:10em;float:right" v-show="item.edit"   >
                    <b-form-input
                     min=1 v-model="item.quantity" :ref="'confirmedQuantityEdit-'+item.id" type="number"  
                    size="sm" class="no-shadow p-1" @keyup.native.enter="saveBackOrderQuantity(item)" @blur="saveBackOrderQuantity(item)"></b-form-input>
                        <div class="input-group-append"  size="sm" >
                        <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="saveBackOrderQuantity(item)" ><i  class="fas fa-edit font-size-14"></i></b-button>
                        </div>
                </div>
            </div>
            <div v-else>
                <b-spinner v-if="isQuantityEditStarting" small ></b-spinner>
            </div>
            
            <!-- <div v-if="role==1">
                {{ item.quantity }} 
            </div> -->

        </template>
        <template v-slot:cell(action)="{item}">
            <b-button @click="cancelBackOrder(item)"  size="sm" variant="outline-danger" >
                  <b-spinner v-if="isCancelBackOrderStarting" small ></b-spinner>
                  <i class="fas fa-times font-size-16 align-middle mr-2"></i>{{$t("buttons.cancel")}}
            </b-button> 
        </template>

        <template  v-slot:cell(stockStatus)="{value}">
            <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
            <div v-else-if="value==3"  class="font-size-18"> _</div>
            <i v-else :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
        </template>
        </b-table>
        <span v-if="!isTableLoading && !itemsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('cartTab.tabEmpty')}}</span>
        </div>

        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="findBackOrders()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findBackOrders()" :disabled="isTableLoading" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->

        <b-modal
        v-if="order.id"
        v-model="showOrdersDetailsModal"
        :title="$t('ordersDetailsModal.title')"
        centered 
        title-class="text-primary"
        title-tag="h5"
        header-close-variant="danger"
        class="modal-fullscreen"
        size="xl"
        full-screen
        no-close-on-esc
        hide-footer
        >
            <OrderModal :orderId="this.order.id" v-on:update="closeOrderModal" />
        </b-modal>
        <b-modal  
            v-model="isConversionStarting" 
            hide-footer 
            hide-header 
            centered  
            no-close-on-esc   
            no-close-on-backdrop  
            >
            <div class="zoom-container">
            <div class="text-center font-size-18">{{ $t("cartTab.covertingModal") }} </div><br>
            <div class="d-flex justify-content-center">
                <div class="spinner-border text-success" role="status">
                </div>
            </div> 
            </div>   
        </b-modal>

      </div>

</template>